import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { DataTableDirective } from 'angular-datatables';
import { collapseColumns } from '../../shared/models/collapseColumns';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ValidationService } from '../../shared/providers/validation.service';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { ToastService } from '../../shared/providers/toast.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { CommonService } from '../../shared/providers/common.service';
import { UserManagerService } from '../../shared/providers/user-manager.service';
import { ILookUp } from '../../shared/models/LookUpOutputModel';
import { PropertyStatus } from '../../shared/enum/enum';
import { IChangePropertyStatus } from '../../shared/models/ChangePropertyStatusInputModel';

export enum Actions {
  NothingSelected = 0,
  Approve = 1,
  Reject = 2,
  ApproveTenant = 3
}

interface IAdvanceFilter {
  TenantName: string;
  BrokerName: string;
  Principal: string;
  StatusId: number;
  PropertyType: number;
  Date: Date;
}

@Component({
  selector: 'app-portfolio-approval-list',
  templateUrl: './portfolio-approval-list.component.html',
  styleUrls: ['./portfolio-approval-list.component.css']
})
export class PortfolioApprovalListComponent implements OnInit {
  constructor(private http: HttpClient, protected _propertyListingService: PropertyListingService, private userManagerService: UserManagerService,
    public authService: AuthenticationService, public Validation: ValidationService, private _commonService: CommonService,
    private modalService: BsModalService, private _toastService: ToastService, private router: Router, private Loader: LoaderService) { }
  dtOptions = {};
  modalRefBOV: BsModalRef;
  modalRefBOVList: BsModalRef;
  sellerId = null;
  propertyId = 0;
  statusList: ILookUp[];
  bovUserId = 0;
  selectedId = 0;
  user = {} as any;
  New = "0";
  initialLoad = true;
  Contacted = "0";
  TotalProperties = 0;
  Cancelled = "0";
  InquiryTotal = 0;
  TotalCount = 0;
  Available = 0;
  OffMarket = 0;
  Others = 0;
  activefilterButton = '';
  protected readonly BASE_URL: string = environment.base_url;
  bovList = [];

  selctedAction = Actions.Approve
  actions = Actions;
  modalRefApprove: BsModalRef;
  isPortfolio = false;
  bovStatusList = [];
  status = '';
  userId = 0;
  filter = "";
  BOVRequest = {};
  advanceFilter = {} as IAdvanceFilter;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  callFrom = 2;

  @Input() sellerIdToFilter = 0;
  @Input() parentPageId = 0;
  pageName = 'Off-Market Deal Approval';
  viewAsChild = false;
  searchCriteria = {};
  IsLoading = false;
  ngOnInit() {
    this.onClearFilter();
    this.viewAsChild = this.sellerIdToFilter > 0;

    this._commonService.getLookupsByTypeId(17).subscribe(response => {
      this.statusList = response.filter(i => i.Description != 'Closed').map(o => { return { id: o.Id, description: o.Description }; });

    });
    this.user = this.authService.user;
    this.userId = (this.authService.Admin() || this.authService.SuperAdmin()) ? 0 : this.user.Id;

    let TableColums = [{ data: 'Id' },
    { data: 'Id' },
    { data: 'TenantName' },
    { data: 'FirstName' },
    { data: 'Date' },
    { data: 'City' },
    { data: 'Status' },
    { data: 'PropertyCreated' },
    { data: 'Broker' }
    ];

    let order = 2;
    var that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "pageLength": 50,
      "order": [[order, "desc"]],
      bLengthChange: false,
      //initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        const filtr = {
          SearchText: this.filter,
          Status: this.status,
          TenantName: this.advanceFilter.TenantName,
          BrokerName: this.advanceFilter.BrokerName,
          Principal: this.advanceFilter.Principal,
          StatusId: this.advanceFilter.StatusId ? this.advanceFilter.StatusId : 0,
          DateString: this.Validation.IsDate(this.advanceFilter.Date) ? this.Validation.formatDatetoMMDDYYYY(this.advanceFilter.Date) : null,
          LoggedInUserId: this.user.Id
        };

        dataTablesParameters.Extra_param = filtr;
        const httpHeader = this.Validation.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/dataentryproperty/OffMarketApprovalRequests/' + this.user.Id,
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            this.bovList = resp.data;
            this.bovList.forEach(item => {
              item.Date = this.Validation.convertUTCDateToLocalDate(item.Date);
            });

            //if (this.initialLoad) {
            this.TotalCount = resp.recordsTotal;
            //}
            that.initialLoad = false;
            if (resp.recordsTotal === 0) {
              $(".dataTables_paginate.paging_full_numbers").hide()
            }
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }


            $(".paginate_button.first,.paginate_button.last").hide();
            this.IsLoading = false;
          });
      },
      columns: TableColums
    };

    this.setStatusFilter();

  }

  changeInquiryStatus(statusId: number, inquiryId: number) {
    this._propertyListingService.ChangeApprovalStatus(statusId, inquiryId).subscribe(response => {
      if (response) {

        this._toastService.addToast({
          title: 'Success', msg:
            'Status updated successfully', timeout:
            2000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        });

        this.setStatusFilter();
      }
      else {
        this._toastService.addToast({
          title: 'Error', msg:
            'Error updating status', timeout:
            2000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
        });
      }
    });

    event.preventDefault();

  }

  setStatusFilter() {
    this._propertyListingService.GetOffMarketApprovalStatusCount().subscribe(res => {

      this.bovStatusList = res;
      this.New = this.bovStatusList.filter(i => i.Key == "New").map(i => i.Value)[0];
      this.Contacted = this.bovStatusList.filter(i => i.Key == "Contacted").map(i => i.Value)[0];
      this.Cancelled = this.bovStatusList.filter(i => i.Key == "Cancelled").map(i => i.Value)[0];
      this.InquiryTotal = Number(this.New ? this.New : 0) + Number(this.Contacted ? this.Contacted : 0);

      this.Available = this.bovStatusList.filter(i => i.Key == "Available").map(i => i.Value)[0];
      this.OffMarket = this.bovStatusList.filter(i => i.Key == "Off-Market").map(i => i.Value)[0];
      this.TotalProperties = this.bovStatusList.filter(i => i.Key == "TotalCount").map(i => i.Value)[0];
      this.Others = this.bovStatusList.filter(i => i.Key == "Others").map(i => i.Value)[0];
      /*this.TotalProperties = Number(this.Available ? this.Available : 0) + Number(this.OffMarket ? this.OffMarket : 0);*/
    });
  }

  search() {
    this.dtElement.dtInstance.then(x => x.draw(false));
  }
  setFilter(key: string) {
    this.status = key;
    this.activefilterButton = key;
    this.resetAdvanceFilter();
    this.search();
  }
  reset() {
    this.filter = "";
    this.status = "";
    this.activefilterButton = "";
    this.dtElement.dtInstance.then(x => x.draw(false));
  }
  redirectOnCellClick(propertyGuid, bovId) {
    if (propertyGuid != null) {
      this.router.navigateByUrl('/viewproperty/' + propertyGuid + "?prevroute=" + this.pageName + "&link=" + encodeURIComponent(this.router.url));
    }
    else {
      this.router.navigateByUrl('/portfolio-property/' + bovId + "?prevroute=" + this.pageName + "&link=" + encodeURIComponent(this.router.url));
    }
  }

  selectedProperty = "";
  isBulkAction = false;

  openModal(event, template: TemplateRef<any>, propId: number, classes: string, action: number) {
    this.propertyId = propId;
    let property = this.bovList.find(x => x.Id == propId);
    this.selectedProperty = property.TenantName + (property.State ? ", " + property.State : "") + (property.City ? ", " + property.City : "");
    this.selctedAction = action;
    this.isBulkAction = false;
    this.modalRefApprove = this.modalService.show(template, { class: classes });
  }

  propertyStatus = PropertyStatus;
  changePropertyStatus = {} as IChangePropertyStatus;

  changeStatus() {
    this.Loader.display(true);
    this.changePropertyStatus.PropertyIds = [];
    this.changePropertyStatus.PropertyIds.push(this.propertyId);
    this.changePropertyStatus.UserId = this.user.Id;

    if (this.selctedAction == Actions.Approve) {
      this.changePropertyStatus.Status = this.propertyStatus.Available;
      this.changePropertyStatus.Comments = null;
      this._propertyListingService.BulkStatusChangeWithComments(this.changePropertyStatus).subscribe(response => {
        if (response) {
          this.dtElement.dtInstance.then(x => x.draw(false));

          this._toastService.addToast({ title: 'Success', msg: 'Status changed successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
          this.reset();
          this.modalRefApprove.hide();
        }
        else {
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to change status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          this.modalRefApprove.hide();
        }
        this.Loader.display(false);
      });
    }
    else if (this.selctedAction == Actions.Reject) {
      this._propertyListingService.RejectOffMarketApproval(this.propertyId).subscribe(response => {
        if (response) {
          this.dtElement.dtInstance.then(x => x.draw(false));

          this._toastService.addToast({ title: 'Success', msg: 'Status changed successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
          this.reset();
          this.modalRefApprove.hide();
        }
        else {
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to change status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          this.modalRefApprove.hide();
        }
        this.Loader.display(false);
      });

    }
  }

  openBOVRequestModal(template: TemplateRef<any>, classes: any) {
    this.modalRefBOV = this.modalService.show(template, { class: classes });
  }
  openAssignBrokerModal(template: TemplateRef<any>, classes: any, id, propertyId) {
    this.selectedId = id;
    this.propertyId = propertyId == null ? 0 : propertyId;
    this.modalRefBOVList = this.modalService.show(template, { class: classes });
  }

  addBroker(event) {
    this._propertyListingService.AssignBrokerToProperty(event.Id, this.selectedId).subscribe(res => {
      this.search();
      this.propertyId = 0;
      this.selectedId = 0;
      if (res) {
        this._toastService.addToast({ title: 'Success', msg: 'Broker assigned successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Error, Selected Broker Information Invalid', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    })
  }
  openInviteModal(template: TemplateRef<any>, classes: any, id) {
    this.bovUserId = id;
    this.modalRefBOVList = this.modalService.show(template, { class: classes });
  }

  addTenantGuarantor() {
    var that = this;
    this._propertyListingService.ApproveTenantAndGuarantor(this.propertyId).subscribe(item => {

      this.modalRefApprove.hide();
      this.dtElement.dtInstance.then(x => x.draw());
      that.Loader.display(false);
    });
  }
 
  redirectProperty() {
    this.router.navigateByUrl('/property?request=bov');
  }
  submitRequest(event) {
    this.search();
    this.setStatusFilter();
  }

  onClearFilter(val = 0) {
    this.resetAdvanceFilter();
    if (val == 1) {
      this.dtElement.dtInstance.then(x => x.draw(false));
    }
  }

  resetAdvanceFilter() {
    this.advanceFilter = {} as IAdvanceFilter;
    this.advanceFilter.PropertyType = 0;
    this.advanceFilter.StatusId = null;
    this.advanceFilter.Date = null;
  }
  onDateSelect() {

  }
  onSearch() {
    this.filter = '';
    this.status = '';
    this.dtElement.dtInstance.then(x => x.draw(false));
  }
}

